"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBitmapText_1 = __importDefault(require("../getBitmapText"));
const state_1 = __importDefault(require("../../state"));
const drawText = (text, color, x, y, size, maxWidth, maxLines, horizontalAlignment, verticalAlignment) => {
    const sprite = (0, getBitmapText_1.default)(text, color, size, maxWidth, maxLines, horizontalAlignment);
    const startX = x - size;
    sprite.x = horizontalAlignment === "right"
        ? startX - sprite.width
        : horizontalAlignment === "center"
            ? startX - Math.ceil(sprite.width / 2)
            : startX;
    sprite.y = verticalAlignment === "bottom"
        ? y + size * 3
        : verticalAlignment === "middle"
            ? y
            : y - size * 3;
    sprite.anchor.set(0, verticalAlignment === "bottom"
        ? 1
        : verticalAlignment === "middle"
            ? size * 7 / 2 / (size * 7)
            : 0);
    sprite.zIndex = 10004;
    state_1.default.app.stage.addChild(sprite);
};
exports.default = drawText;
